// Static (non-menu) data for Golden Tulip Digital Concierge.
// Menu items now live in the database, managed via Staff Dashboard > Kelola Konten.

export const HOTEL_PHONE = "+623413302000";

export const formatRupiah = (n) => "Rp " + n.toLocaleString("id-ID");
